import React from "react";

export default function MadhyaPradesh() {
  return (
    <div>
      <h1>Madhya Pradesh</h1>
      <p>Welcome to the Madhya Pradesh page!</p>
    </div>
  );
}